import { MiniSwitch } from "@/ui-kit";
import { useSignupDispatch } from "components/Signup/store/hooks";
import { updateBillingInterval } from "components/Signup/store/slices/animals";
import {
  BillingInterval,
  MONTHLY_BILLING_INTERVAL,
  YEARLY_BILLING_INTERVAL,
} from "utils/insurance";
import styles from "./BillingIntervalSelector.module.css";
import { useBillingInterval } from "components/Signup/store/selectors/animals";
import { useWebTranslation } from "translations";

export const BillingIntervalSelector = () => {
  const dispatch = useSignupDispatch();
  const { t } = useWebTranslation();
  const billingInterval = useBillingInterval();

  return (
    <MiniSwitch<BillingInterval>
      options={[
        { label: t("global.date.monthly"), value: MONTHLY_BILLING_INTERVAL },
        { label: t("global.date.yearly"), value: YEARLY_BILLING_INTERVAL },
      ]}
      value={billingInterval}
      onChange={(billingInterval) => {
        dispatch(updateBillingInterval(billingInterval));
      }}
      className={styles.switch}
    />
  );
};
